(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collasibpel"] && !Shopify.designMode) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.header = el.querySelector('.accordion-header');
      this.content = el.querySelector('.accordion-content');
      this.isExpanded = false;

      this.header.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      this.isExpanded = !this.isExpanded;
      this.header.setAttribute('aria-expanded', this.isExpanded);
      
      if (this.isExpanded) {
        this.expand();
      } else {
        this.collapse();
      }
    }

    expand() {
      this.content.style.height = this.content.scrollHeight + 'px';
      this.el.classList.add('is-expanded');
    }

    collapse() {
      this.content.style.height = '0px';
      this.el.classList.remove('is-expanded');
    }
  }

  document.querySelectorAll('.accordion-item').forEach(item => {
    new Accordion(item);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hotspot-trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      document.querySelectorAll('.hotspot-item').forEach(item => {
        item.classList.remove('hotspot-active');
      });
      document.querySelectorAll('.hotspot-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      
      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.closest('.hotspot-item').classList.add('hotspot-active');
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.hotspot-item')) {
      document.querySelectorAll('.hotspot-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      document.querySelectorAll('.hotspot-item').forEach(item => {
        item.classList.remove('hotspot-active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
